import LayoutV1 from './v1/layout';
import LayoutV2 from './v2/layout';
import { LayoutType } from './const';

const Layout =
  parseInt(sessionStorage.getItem('layout-version') ?? '2', 10) === 2
    ? LayoutV2
    : LayoutV1;

export { Layout, LayoutType };
